var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('img',{attrs:{"src":"/assets/img/icon-arrow-left.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }